export var ACCESS_TOKEN = 'accessToken';
export var REFRESH_TOKEN = 'refreshToken';
export var QUERY_KEYS = {
    USER_INFO: 'USER_INFO',
    ITEMS_LIST: 'ITEMS_LIST',
    ACCOUNT_LIST: 'ACCOUNT_LIST',
    DEPARTMENT_LIST: 'DEPARTMENT_LIST',
    DEPARTMENT_DETAIL: 'DEPARTMENT_DETAILS',
    ACCOUNT_DETAIL: 'ACCOUNT_DETAIL',
    MULTI_LANGUAGES: 'MULTI_LANGUAGES',
    CASHFLOW_TEAMPLATE_LIST: 'CASHFLOW_TEAMPLATE_LIST',
    CASHFLOW_TEMPLATE_DETAIL: 'CASHFLOW_TEMPLATE_DETAIL',
    SYSTEM_LANGUAGES_VALUES: 'SYSTEM_LANGUAGES_VALUES',
    SYSTEM_LANGUAGE_DETAIL_KEY: 'SYSTEM_LANGUAGE_DETAIL_KEY',
    CASHFLOW_STATEMENT_LIST: 'CASHFLOW_STATEMENT_LIST',
    CASHFLOW_STATEMENT_DETAIL: 'CASHFLOW_STATEMENT_DETAIL',
    DEPARTMENT_TREE_LIST: 'DEPARTMENT_TREE_LIST',
    CASHFLOW_OVERVIEW: 'CASHFLOW_OVERVIEW',
    CASHFLOW_ITEM_LIST: 'CASHFLOW_ITEM_LIST',
    CASHFLOW_TEMPLATE_PUBLISH: 'CASHFLOW_TEMPLATE_PUBLISH',
    AP_OVERVIEW: 'AP_OVERVIEW',
    SUPPLIER_ITEM_LIST: 'SUPPLIER_ITEM_LIST',
    SUPPLIER_BALANCE_LIST: 'SUPPLIER_BALANCE_LIST',
    SUPPLIER_DETAIL: 'SUPPLIER_DETAIL',
    SUPPLIER_CODE: 'SUPPLIER_CODE',
    SUPPLIER_NAME_LIST: 'SUPPLIER_NAME_LIST',
    AR_OVERVIEW: 'AR_OVERVIEW',
    CUSTOMER_LIST: 'CUSTOMER_LIST',
    CUSTOMER_ITEM_LIST: 'CUSTOMER_ITEM_LIST',
    CUSTOMER_CODE: 'CUSTOMER_CODE',
    CUSTOMER_BALANCE_LIST: 'CUSTOMER_BALANCE_LIST',
    COUNTRY: 'COUNTRY',
    PAYMENT_PROPOSAL: 'PAYMENT_PROPOSAL',
    PAYMENT_PROPOSAL_LIST: 'PAYMENT_PROPOSAL_LIST',
    PAYMENT_TRANSACTION_LIST: 'PAYMENT_TRANSACTION_LIST',
    TRANSACTION_DETAIL: 'TRANSACTION_DETAIL',
    DUNNING_PROCEDURE_LIST: 'DUNNING_PROCEDURE_LIST',
    EXECUTION_LIST: 'EXECUTION_LIST',
    DUNNING_PROCEDURE: 'DUNNING_PROCEDURE',
    CUSTOMER_RECEIVABLE_LIST: 'CUSTOMER_RECEIVABLE_LIST'
};
export var COOKIE_KEYS = {
    ACCESS_TOKEN: 'ACCESS_TOKEN'
};
